import { CSSObject } from '@chakra-ui/react';

export const EventsClosedContainer: CSSObject = {
  minH: '12',
  p: '2.5',
  alignItems: 'start',
};
